import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { SelectLanguagePopup } from './SelectLanguagePopup';

export const SELECT_LANGUAGE_POPUP = Symbol('SELECT_LANGUAGE');

export const useSelectLanguagePopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(SELECT_LANGUAGE_POPUP, SelectLanguagePopup);
  });

  return useCallback(
    ({ language, onSubmit, disabled }) => {
      popups.openPopup(SELECT_LANGUAGE_POPUP, {
        language,
        disabled,
        onSubmit: (result) => {
          popups.closePopup(SELECT_LANGUAGE_POPUP);
          onSubmit(result);
        },
        onClose: () => {
          popups.closePopup(SELECT_LANGUAGE_POPUP);
        },
      });
    },
    [popups]
  );
};
